OT.createNS('OT.Search.Scroll');

OT.Search.Scroll = function() {
    'use strict';

    var getFilterBarHeight = function () {
            return $('#filters-bar').height();
        },
        getContainerTop = function() {
            return $("#search_results_container").offset().top;
        },
        scrollToTop = function() {
            var currentTopPosition = $(document).scrollTop();
            var topOfFilters = getContainerTop() - getFilterBarHeight();

            if (currentTopPosition <= topOfFilters) {
                return;
            }

            $("body,html").animate({
                scrollTop: topOfFilters
            }, 500);
        };

    return {
        scrollToTop: scrollToTop
    };
};